import { render, staticRenderFns } from "./monitorDetail.vue?vue&type=template&id=0e15019e&scoped=true&"
import script from "./monitorDetail.vue?vue&type=script&setup=true&lang=js&"
export * from "./monitorDetail.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./monitorDetail.vue?vue&type=style&index=0&id=0e15019e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e15019e",
  null
  
)

export default component.exports